import * as putil from '@bingads-webui-universal/primitive-utilities';
import { AdjustmentType } from '../adjustment-type';
import { dataExclusionErrorMap, seasonalityErrorMap } from './error-map';

export function localizeErrorCode(errorCode, i18n, adjustmentType) {
  if (errorCode) {
    const errorString = adjustmentType === AdjustmentType.SeasonalityAdjustment ?
      seasonalityErrorMap[errorCode] :
      dataExclusionErrorMap[errorCode];
    if (errorString) {
      return i18n.getString(errorString);
    }
  }
  return i18n.getString(_TL_("We've encountered an error and could not finish this task. Please try again or contact support."));
}

export function localizeApiError(error, i18n, adjustmentType) {
  const firstError = putil.get(error, 'errors[0]', {});
  const errorCode =
    // for OData error
    firstError.Code ||
    // for bulk upsert error
    firstError.Error;

  return localizeErrorCode(errorCode, i18n, adjustmentType);
}
